module.exports = __webpack_public_path__ + "static/media/aviso_eleicoes_2026.74fb88e4.png";